import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Truck, TruckGroup } from '../../truck-group.model';
import { DialogService } from '@sdbn/common';
import { TruckSearchComponent } from './truck-search/truck-search.component';

@Component({
  selector: 'app-trucks',
  templateUrl: './trucks.component.html',
  styleUrls: ['./trucks.component.scss']
})
export class TrucksComponent implements OnInit {

  @Input() currentTruckGroup: TruckGroup;

  @Input() editable: boolean;

  @Output() trucksChanged = new EventEmitter<boolean>();


  constructor(private dialogService: DialogService) { }

  ngOnInit() { }

  onAdd() {
    this.dialogService.openMaxHeight(TruckSearchComponent, new TruckGroup(this.currentTruckGroup)).afterClosed().subscribe((result: Truck | null) => {
      if (result != null) {
        if (!this.currentTruckGroup.trucks.some(values => values.id == result.id)) {
          this.currentTruckGroup.trucks.push(result)
          this.trucksChanged.emit(true);
        }
      }
    })
  }

  removeTruck(truck: Truck) {
    const index = this.currentTruckGroup.trucks.indexOf(truck);
    this.currentTruckGroup.trucks.splice(index, 1);
  }

}
